import {
    WithId,
} from 'app/types/common.types'
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type BatchOperationsRequests = {
    start: RequestConfigFunction,
    cancel: RequestConfigFunction<WithId<number>>,
    complete: RequestConfigFunction<WithId<number>>,
}
const batchOperationsRequests: BatchOperationsRequests = {
    start: () => {
        return {
            url: 'batchoperation',
            method: 'POST',
        }
    },
    cancel: ({
        id,
    }) => {
        return {
            url: `batchoperation/${id}/cancel`,
            method: 'PATCH',
        }
    },
    complete: ({
        id,
    }) => {
        return {
            url: `batchoperation/${id}/complete`,
            method: 'PATCH',
        }
    },
}

export default batchOperationsRequests
